// platform/app/src/hooks/useClientSlackChannels.ts
import { useQuery } from '@tanstack/react-query'
import { supabase } from '@loop3/supabase-client'
import type { ClientSlackChannel } from '@/lib/types'

export function useClientSlackChannels(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client-slack', clientId],
    queryFn: async (): Promise<ClientSlackChannel[]> => {
      const { data, error } = await supabase
        .from('client_slack_channels')
        .select('id, client_id, name, kind, channel_id, url, sort_order')
        .eq('client_id', clientId!)
        .order('sort_order', { ascending: true })
      if (error) throw error
      return (data ?? []) as ClientSlackChannel[]
    },
    enabled: !!clientId,
    staleTime: 60_000,
  })
}
